import React, { useState, useEffect } from "react";
import BaseModal from "../../../../components/ui/BaseModal";
import BaseDragDrop from "../../../../components/ui/BaseDragDrop";
import BaseButton from "../../../../components/ui/BaseButton";

const fileTypeIcon = (fileName = "") => {
  const name = fileName.toLowerCase();
  if (name.endsWith(".pdf")) return "fa-file-pdf text-red-500";
  if (/\.docx?$/.test(name)) return "fa-file-word text-blue-500";
  if (/\.(csv|xlsx?|xlsm)$/.test(name)) return "fa-file-excel text-green-600";
  if (/\.(pptx?)$/.test(name)) return "fa-file-powerpoint text-orange-500";
  if (/\.(zip|rar|7z)$/.test(name)) return "fa-file-zipper text-amber-600";
  return "fa-file-lines text-gray-500";
};

const ChatFileUploadModal = ({
  open,
  close,
  handleDone,
  setSelectedFiles,
  fileInputRef,
  triggerFileSelect,
}) => {
  const [tempFiles, setTempFiles] = useState([]);
  useEffect(() => {
    if (open) setTempFiles([]);
  }, [open]);

  const handleTempFileChange = (files) => {
    const newFiles = Array.from(files).map((file) => ({
      file,
      previewURL: URL.createObjectURL(file),
    }));

    setTempFiles((prev) => {
      const existing = prev.map((f) => f.file.name + f.file.size);
      const uniqueFiles = newFiles.filter((f) => !existing.includes(f.file.name + f.file.size));
      return [...prev, ...uniqueFiles];
    });

    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleFile = () => {
    handleDone(tempFiles);

    close();
  };

  return (
    <BaseModal
      className="-top-[200px] overflow-auto"
      open={open}
      close={close}
      style={{ width: "1000px" }}
    >
      <div className="py-7 px-12">
        <h6 className="text-dark font-normal border-b pb-1">Upload Files</h6>

        <BaseDragDrop
          className="flex flex-col mt-8 items-center justify-center p-10 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer"
          onDrop={handleTempFileChange}
        >
          <i className="fa-solid fa-paperclip text-primary text-5xl mb-4"></i>
          <p className="text-dark font-normal mb-2 text-base">
            Drag & Drop files here or click below
          </p>
          <BaseButton
            color="primary"
            textSize="text-base"
            className="py-[6px]"
            onClick={() => triggerFileSelect}
          >
            Choose Files
          </BaseButton>
          <input
            type="file"
            multiple
            style={{ display: "none" }}
            onChange={(e) => handleTempFileChange(e.target.files)}
          />
        </BaseDragDrop>

        {tempFiles.map((f, idx) => (
          <div
            key={idx}
            className="flex items-center justify-between bg-light rounded-md py-2 px-3 cursor-default mt-2"
          >
            <p className="truncate">{f.file.name}</p>
            {/* Only an image previews as one — a pdf or a sheet handed to
                            <img> just drew a broken-image glyph. */}
            {f.file.type?.startsWith("image/") ? (
              <img src={f.previewURL} className="h-12 w-12 object-cover" alt="preview" />
            ) : (
              <i className={`fa-solid ${fileTypeIcon(f.file.name)} text-2xl w-12 text-center`}></i>
            )}
          </div>
        ))}
      </div>
      <div
        className="d-flex content-center  bg-white py-6 "
        style={{
          boxShadow: "0px 0px 14px 0px rgba(0, 0, 0, 0.07)",
        }}
      >
        <BaseButton
          className=" px-[28px] py-[5px] bg-light text-primary hover:!text-primary"
          variant="outlined"
          color="primary"
          style={{
            marginRight: "16px",
          }}
          onClick={close}
        >
          Cancel
        </BaseButton>

        <BaseButton className="py-[5px] px-[20px] min-w-32" color="primary" onClick={handleFile}>
          Done
        </BaseButton>
      </div>
    </BaseModal>
  );
};

export default ChatFileUploadModal;
